import React from "react"
import { Form, Select, Tag, Flex } from "antd"
import { CloseCircleOutlined } from "@ant-design/icons"
import { useTranslation } from "react-i18next"
import PropTypes from "prop-types"
import styles from "../index.module.css"
import { Text } from "ui/Typography"

export const ExperienceSelector = ({
  form,
  dropdownOptions,
  experienceOptions,
  dropdownOpen,
  setDropdownOpen,
  renderExperienceDropdown,
  errorMessages
}) => {
  const { t } = useTranslation()

  return (
    <div className={styles.questionCard}>
      <Form.Item name="experience" className={styles.selectWrap}>
        <Select
          style={{ minWidth: 240 }}
          mode="multiple"
          placeholder={""}
          optionLabelProp="label"
          dropdownStyle={{ padding: 0 }}
          dropdownRender={renderExperienceDropdown}
          dropdownMatchSelectWidth={false}
          tagRender={() => null}
          options={dropdownOptions}
          open={dropdownOpen}
          onDropdownVisibleChange={setDropdownOpen}
        />
        <span className={styles.customPlaceholder}>{t("settings.experience_placeholder")}</span>
      </Form.Item>
      <Flex gap={8} className={styles.selectedWrap}>
        {(form.getFieldValue("experience") || []).length === 0 && <Tag className="py-xxs px-xs">No Experience selected</Tag>}
        {(form.getFieldValue("experience") || []).map((val) => {
          const selectedOption = dropdownOptions.find((option) => option.value === val)
          return (
            <Tag
              className={styles.experienceTag}
              key={val}
              closable
              closeIcon={<CloseCircleOutlined />}
              onClose={(e) => {
                e.stopPropagation()
                const prev = form.getFieldValue("experience") || []
                form.setFieldsValue({ experience: prev.filter((v) => v !== val) })
              }}
            >
              {selectedOption?.label || val}
            </Tag>
          )
        })}
      </Flex>
      {errorMessages && (
        <Text type="danger" className={styles.errorMessages}>
          {errorMessages}
        </Text>
      )}
    </div>
  )
}

ExperienceSelector.propTypes = {
  form: PropTypes.object.isRequired,
  dropdownOptions: PropTypes.array.isRequired,
  experienceOptions: PropTypes.array,
  dropdownOpen: PropTypes.bool.isRequired,
  setDropdownOpen: PropTypes.func.isRequired,
  renderExperienceDropdown: PropTypes.func.isRequired,
  errorMessages: PropTypes.string
}
